<template>
  <div class="cont_body" v-if="optionsData">
    <div class="list_cont">
      <div class="list_img">
        <img v-if="optionsData.headImg" :src="getImg(optionsData.headImg)" alt="">
        <img v-else src="@/assets/img/userPhoto.jpg" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.name}} 
          <!-- <span>· 投资副总监</span> -->
        </h4>
        <div class="list_cont_mid">
          <!-- <p>投资额度：{{optionsData.investmentAmount}}万元</p> -->
          <!-- <p>投资阶段：成长期</p> -->
          <p>联系电话：{{optionsData.contactNumber}}</p>
          <p>投资地区：{{optionsData.address}}</p>
        </div>
        <div class="list_cont_end">
          <a-tag v-for="(item,key) in optionsData.majorField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </a-tag>
        </div>
      </div>
      <div class="list_botton">
        <a-button size="large" @click="onAdd" style="width:120px;" >咨询</a-button>
      </div>
    </div>
    <div class="list_bottom">
      <h4>金融顾问简介</h4>
      <p v-html="optionsData.introduce">
        
      </p>
    </div>
  </div>
  <a-modal width="600px" title="咨询" v-model:visible="visible" :maskClosable="false" :closable="false"  @ok="onSubmit" @cancel="handleCancel">
    <a-form :labelCol="{span:6}" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
        <a-row :gutter="[24,8]">
          <a-col :span="24">
              <div class="hidden">
                  <a-form-item label="当前id" name="sendId">
                      <a-input v-model:value="form.sendId" placeholder="请输入当前id" />
                  </a-form-item>
                  <a-form-item label="本条id" name="receiveId">
                      <a-input v-model:value="form.receiveId" placeholder="请输入本条id" />
                  </a-form-item>
              </div>
              <a-form-item :labelCol='{span:4}' label="联系人姓名" name="contacts">
                  <a-input v-model:value="form.contacts" placeholder="请输入联系人姓名" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="联系人电话" name="contactNumber">
                  <a-input v-model:value="form.contactNumber" placeholder="请输入联系人电话" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="对接备注" name="content">
                  <a-textarea v-model:value="form.content" placeholder="请输入对接备注"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
              </a-form-item>
          </a-col>
        </a-row>
    </a-form>
</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { dictMixin } from "@/mixins";
import {financeAdvisorWeb,financeConsultation} from "@/api/finance";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {
    formMixin
} from "@/mixins";
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [formMixin,dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictNames: 'investmentField',
      optionsData:null,
      visible:false,
      role: null,
      form: {
          projectId: null,
          sendId: null,
          receiveId: null,
          contacts: null,
          contactNumber: null,
          content: null,
          processingState: null,
      },
      rules: {
          projectId: [dataCheck.required({})],
          sendId: [],
          receiveId: [],
          contacts: [dataCheck.required({})],
          contactNumber: [dataCheck.required({})],
          processingState: [dataCheck.required({})],
          content: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return financeConsultation.add
      }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: financeAdvisorWeb.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.form.receiveId = res.userId
        this.form.sendId = this.$ls.get('notificationId')
        this.role = this.$ls.get('roleCode').replace("[","").replace("]","").replace("\"","").replace("\"","").replace("\"","").replace("\"","").split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
      })
     
      
    }
  },
	methods: {
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
            }
            this.form.senderContact=null,
            this.form.contactNumber=null,
            this.form.content=null
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
:deep(.ant-tag){
  background: #e4e6fc;
  border-radius: 2px;
  border:none;
  padding:2px 10px;
}
.list_cont{
  width: 100%;
  padding:20px 0;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      background: #1890ff;
      color:#fff
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>